<template>
    <v-container>
        <v-card class="card-tel">
            <v-dialog v-model="numerosModal" persistent scrollable content-class="tel-modal"
                      transition="dialog-bottom-transition">
                <template>
                    <v-card style="height: 100% !important">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Iniciar Conversación</v-toolbar-title>
                        </v-card-title>
                        <v-progress-linear color="green accent-4" indeterminate rounded height="6"
                                           v-if="cargarConver"></v-progress-linear>
                        <v-col col-md="8" class="text-center">
                            <span style="margin-bottom: 10%">Selecciona un número de teléfono</span>
                            <br />
                            <span class="files-report-label-style">Número de teléfono:</span>
                            <multiselect v-model="telefonosNews.stnumero" style="margin-top: 5%" selected-label="Seleccionado"
                                         label="telofuscado" :max-height="110" placeholder="Teléfono" :options="telefonosNews.telefonosNO"
                                         :allow-empty="false" @input="onSelect">
                            </multiselect>
                        </v-col>
                        <v-col class="text-center">
                            <span style="color: red" v-if="spanModal">
                                Debe seleccionar un número de teléfono
                            </span>
                        </v-col>

                        <v-card-actions class="justify-center botonesModal">
                            <v-btn color="primary" @click="IniciarConversacion(telefonosNews.stnumero)" :disabled="buttonInitConver">
                                Iniciar Conversación
                            </v-btn>
                            <v-btn :disabled="buttonInitConver" variant="text" @click="CerrarModal()">Cancelar</v-btn>
                        </v-card-actions>
                    </v-card>
                </template>
            </v-dialog>
            <v-card-text>
                <div style="text-align: center">
                    <v-chip class="ma-2" :color="this.color" large @click="detalleReporte()">
                        <span class="span-reporte"> Reporte: {{ this.RepInd }}</span>
                        <div class="span-etiqueta">{{ this.etiqueta }}</div>
                    </v-chip>
                    <v-tooltip top v-if="mostrarBtn">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn style="align-items: center" v-bind="attrs" v-on="on" :color="color" icon outlined
                                   @click="AbrirModal()">
                                <v-icon size="30" dark>mdi-message-text-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Iniciar Conversacion</span>
                    </v-tooltip>
                </div>
                <div class="card-tel">
                    <v-progress-linear color="green accent-4" indeterminate rounded height="6" v-if="cargar"></v-progress-linear>
                    <v-card v-if="this.mostrarNoTel">
                        <v-card-text> No hay telefonos por mostrar </v-card-text>
                    </v-card>
                    <template v-else>
                        <v-row justify="center" class="mt-2">
                            <v-expansion-panels inset active-class="select-card">
                                <v-expansion-panel v-for="(item, i) in filterTel" :key="i">
                                    <v-expansion-panel-header hide-actions @click="SeleccionarTel(item, i)">
                                        <v-row style="color: black; font-weight: bold">
                                            <v-col cols="12">
                                                {{ item.telofuscado }}
                                            </v-col>
                                            <v-col cols="2" md="2">
                                                <v-icon color="#0091EA">mdi-account</v-icon>
                                            </v-col>
                                            <v-col cols="10" md="10" style="font-size: larger">
                                                {{ item.stadescripcion }}
                                                <div v-if="item.twhNotificacionPendiente == 1">
                                                    <p class="text-right notification-bullet">
                                                        <i class="mdi mdi-brightness-1"></i>
                                                    </p>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-header>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </template>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import { mapActions, mapState } from "vuex";
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import animationData from "@/assets/animations/84745-message.json";
    import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
    import Reporte from "@/services/ExpJur/ExpJur.service.js";

    export default {
        title() {
            return this.$route.meta.title
        },
        components: {},
        data: function () {
            return {
                busquedaTel: "",
                telefonos: [],
                cargar: true,
                cargarConver: false,
                mostrarNoTel: false,
                //
                RepInd: "",
                svfhconclusion: "",
                svfhcerrado: "",
                color: "",
                etiqueta: "",
                numerosModal: false,
                selectError: false,
                mostrarBtn: false,
                telefonosNews: {
                    telefonosNO: [],
                    lbl: "",
                    stnumero: "",
                    telofuscado: "",
                },
                buttonInitConver: false,
                spanModal: false,
                datos: {},
                //
            };
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
            DRAWER_STATE: {
                get() {
                    return this.drawer;
                },
            },
            filterTel() {
                return this.telefonos.filter((telefono) => {
                    return telefono.stnumero.match(this.busquedaTel);
                });
            },
        },
        methods: {
            onSelect() {
                this.spanModal = false;
            },
            getFieldText(item) {
                return `${item.stnumero} - ${item.stadescripcion}`;
            },
            async detalleReporte() {

                let routerName = MetodosGenerales.obtenerRouterName(this.datos.aiclave);
                this.$router.push({ name: `${routerName}` });
            },
            AbrirModal() {
                this.numerosModal = true;
            },
            CerrarModal() {
                this.telefonosNews.stnumero = null;
                this.numerosModal = false;
                this.spanModal = false;
            },
            async IniciarConversacion(telObj) {
                if (telObj == null || telObj.stnumero == null) {
                    this.spanModal = true;
                } else {
                    this.cargarConver = true;
                    this.buttonInitConver = true;
                    this.spanModal = false;
                    const found = this.telefonosNews.telefonosNO.find((element) => {
                        if (element.stnumero === telObj.stnumero) {
                            this.result = this.telefonosNews.telefonosNO.indexOf(element);
                            this.telefonosNews.telefonosNO.splice(this.result, 1);
                            return element;
                        }
                    });

                    if (this.telefonosNews.telefonosNO.length < 1) {
                        this.mostrarBtn = false;
                    }

                    let error = await WhatsappService.IniciarConversacion(
                        this,
                        telObj.stprefijo + telObj.stnumero, this.datos
                    );

                    if (error == false) {
                        this.$swal({
                            position: "center",
                            icon: "success",
                            title: "Correcto!",
                            text: "Se ha enviado el mensaje correctamente.",
                            timer: 4000,
                            showConfirmButton: true,
                        }).then((result) => {
                            this.telefonosNews.stnumero = null;
                            this.numerosModal = false;
                            this.buttonInitConver = false;
                            this.cargarConver = false;
                        });
                    } else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Oops...",
                            text: "Ocurrió un error inesperado al enviar el mensaje, inténtelo nuevamente.",
                            timer: 3000,
                            showConfirmButton: true,
                        }).then((result) => {
                            this.telefonosNews.stnumero = null;
                            this.numerosModal = false;
                            this.buttonInitConver = false;
                            this.cargarConver = false;
                        });
                    }
                }
            },
            async ObtenerTelefonosNoWS() {
                let telefonosTemp = await WhatsappService.TelefonosNoWS(this,this.datos);

                this.telefonosNews.telefonosNO = telefonosTemp;

                if (this.telefonosNews.telefonosNO.length > 0) {
                    this.mostrarBtn = true;
                }
            },
            validarRegex(evt, tipo) {
                return MetodosGenerales.validarRegex(evt, tipo);
            },
            async ObtenerTelefonos() {
                this.cargar = true;
                let telefonos = await WhatsappService.Telefonos(this);
                if (telefonos != null) {
                    this.telefonos = [];
                    for (let i in telefonos) {
                        for (const [key, value] of Object.entries(telefonos[i])) {
                            if (typeof value == "object") {
                                telefonos[i][key] = "";
                            } else {
                                telefonos[i][key] = value.toString();
                            }
                        }
                    }
                    this.telefonos = telefonos;
                    let Abogado = await WhatsappService.ObtenerTelefonosAbogado(this, this.datos);
                    if (Abogado != null) {
                        for (let i in Abogado) {
                            for (const [key, value] of Object.entries(Abogado[i])) {
                                if (typeof value == "object") {
                                    Abogado[i][key] = "";
                                } else {
                                    Abogado[i][key] = value.toString();
                                }
                            }
                            this.telefonos.push(Abogado[i]);
                        }
                    } else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "No se pudieron obtener los teléfonos del abogado, inténtelo más tarde.",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        });
                    }
                    let Supervisor = await WhatsappService.ObtenerTelefonosSupervisor(this,this.datos);
                    if (Supervisor != null) {
                        for (let i in Supervisor) {
                            for (const [key, value] of Object.entries(Supervisor[i])) {
                                if (typeof value == "object") {
                                    Supervisor[i][key] = "";
                                } else {
                                    Supervisor[i][key] = value.toString();
                                }
                            }
                            this.telefonos.push(Supervisor[i]);
                        }
                    } else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "No se pudieron obtener los teléfonos del supervisor, inténtelo más tarde.",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        });
                    }
                    let historial = await WhatsappService.ObtenerTelefonosHistorial(this, this.datos);
                    if (historial != null) {
                        for (let i in historial) {
                            for (const [key, value] of Object.entries(historial[i])) {
                                if (typeof value == "object") {
                                    historial[i][key] = "";
                                } else {
                                    historial[i][key] = value.toString();
                                }
                            }
                            this.telefonos.push(historial[i]);
                        }
                    } else {
                        this.$swal({
                            position: "center",
                            icon: "error",
                            title: "Error",
                            text: "No se pudieron obtener los teléfonos del historial, inténtelo más tarde.",
                            showConfirmButton: true,
                            allowOutsideClick: false,
                        }).then((result) => {
                            if (result.isConfirmed) {
                            }
                        });
                    }
                    this.mostrarNoTel = this.telefonos.length == 0 ? true : false;
                    this.cargar = false;

                    this.$store.commit("fillListaTerminada", this.telefonos);
                } else {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Error",
                        text: "No se pudieron obtener los teléfonos del reporte, inténtelo más tarde.",
                        showConfirmButton: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                        }
                    });
                    this.cargar = false;
                }
            },
            SeleccionarTel(tel, index) {
                this.$emit("chatSeleccionado", tel);
            },
            ocultarTel(telefono, ban) {
                if (!ban) {
                    let chars = 0; // Cantidad de caracters visibles
                    return telefono
                        .split("")
                        .slice(chars, -1)
                        .map((v) => "*")
                        .join("");
                } else {
                    return telefono;
                }
            },
        },
        async mounted() {
            this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
            let encabezado = await Reporte.EncabezadoReporte(this);
            this.RepInd = encabezado.nrreportei;
            this.color = encabezado.color;
            this.etiqueta = encabezado.etiqueta;

            await this.ObtenerTelefonos();
            await this.ObtenerTelefonosNoWS();
        },
    };
</script>


<style>
    .select-card {
        background-color: #00e676 !important;
    }
</style>

<style scoped>
    .textSelect {
        width: 80% !important;
    }

    @media screen and (max-width: 420px) {
        .textSelect {
            width: 100% !important;
        }
    }

    .span-reporte {
        color: white;
        padding-right: 10px;
        font-size: 1.1rem;
    }

    .span-etiqueta {
        font-size: 1rem;
        background-color: white;
        color: black;
        border-radius: 25px;
        padding: 6% 2% 6% 2%;
        font-weight: bold;
    }

    .v-card {
        transition: opacity 0.4s ease-in-out;
    }

    .card_tel :focus {
        background: #00e676;
    }

    .notification-bullet {
        margin: 0;
        color: red;
        margin-top: -27px;
        margin-bottom: 5px;
        font-size: 20px;
    }

    .card-tel {
        height: 90vh;
    }

    /* dispositivos moviles*/
    @media screen and (max-width: 959px) {
        .card-tel {
            height: 100%;
        }

        .span-reporte {
            color: white;
            padding-right: 10px;
            font-size: 1.1rem;
        }

        .span-etiqueta {
            font-size: 0.7rem;
            background-color: white;
            color: black;
            border-radius: 25px;
            padding: 6% 2% 6% 2%;
            font-weight: bold;
        }
    }

    /*-------------------------- */
    @media screen and (min-width: 960px) and (max-width: 1175px) {
        .span-reporte {
            color: white;
            padding-right: 10px;
            font-size: 0.75rem;
        }

        .span-etiqueta {
            font-size: 0.6rem;
            background-color: white;
            color: black;
            border-radius: 25px;
            padding: 6% 2% 6% 2%;
            font-weight: bold;
        }
    }

    @media screen and (min-width: 1176px) and (max-width: 1319px) {
        .span-reporte {
            color: white;
            padding-right: 10px;
            font-size: 0.9rem;
        }

        .span-etiqueta {
            font-size: 0.6rem;
            background-color: white;
            color: black;
            border-radius: 25px;
            padding: 6% 2% 6% 2%;
            font-weight: bold;
        }
    }

    @media screen and (min-width: 1320px) and (max-width: 1530px) {
        .span-reporte {
            color: white;
            padding-right: 10px;
            font-size: 0.95rem;
        }

        .span-etiqueta {
            font-size: 0.6rem;
            background-color: white;
            color: black;
            border-radius: 25px;
            padding: 6% 2% 6% 2%;
            font-weight: bold;
        }
    }

    .botonesModal {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        margin-bottom: 5%;
    }
</style>